/**
 * Helpers for mobile results tab: "relevant" market per sport (summary without odds).
 * Racing: tricast (prefer straight 1006/2006, else combination 1007/2007).
 * Baseball: 4003 (Final outcome + Number of pitches).
 * Football: 5004 (Exact score).
 * Generic: first market in list.
 */

export const BASEBALL_RELEVANT_MARKET_ID = 4003;
export const FOOTBALL_EXACT_SCORE_MARKET_ID = 5004;

const TRICAST_STRAIGHT_GROUP = 6;  // 1006, 2006
const TRICAST_COMBO_GROUP = 7;    // 1007, 2007

/**
 * @param {number[]} marketColumns - sorted market type ids from results
 * @returns {number | null} first tricast market (prefer straight, else combo)
 */
export function getRelevantMarketIdForRacing(marketColumns) {
  if (!Array.isArray(marketColumns) || marketColumns.length === 0) return null;
  const straight = marketColumns.find((mid) => mid % 100 === TRICAST_STRAIGHT_GROUP);
  if (straight != null) return straight;
  return marketColumns.find((mid) => mid % 100 === TRICAST_COMBO_GROUP) ?? null;
}

/**
 * @param {number[]} marketColumns
 * @returns {number | null} first market id or null
 */
export function getRelevantMarketIdForGeneric(marketColumns) {
  if (!Array.isArray(marketColumns) || marketColumns.length === 0) return null;
  return marketColumns[0];
}
